// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODIFIED DATA : 07-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/********************************* START - FETCH BRANCH PROFILE REPORT DATA **********************************/
export const branchProfileReportGet = (listData: any) => {
	const data = {
		FetchBranchProfileReportDataToken: listData,
	};
	const url = `${API_URL}fetchBranchProfileReport`;
	return makeApiCall(url, data);
};
/********************************* END - FETCH BRANCH PROFILE REPORT DATA ************************************/
